"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseDateRangeInput = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var i18n_1 = require("../../i18n");
var styles_1 = require("../../styles");
var react_3 = require("../../util/react");
var DateField_1 = require("../DateField");
var Icon_1 = require("../Icon");
var __1 = require("..");
function BaseDateRangeInput(props) {
    var clearable = props.clearable, disabled = props.disabled, divRef = props.divRef, icon = props.icon, initialInputRef = props.initialInputRef, finalInputRef = props.finalInputRef, maxDate = props.maxDate, minDate = props.minDate, name = props.name, onChange = props.onChange, onIconClick = props.onIconClick, onInputOnFocus = props.onInputOnFocus, rangeSeparator = props.rangeSeparator, value = props.value, style = props.style, rest = __rest(props, ["clearable", "disabled", "divRef", "icon", "initialInputRef", "finalInputRef", "maxDate", "minDate", "name", "onChange", "onIconClick", "onInputOnFocus", "rangeSeparator", "value", "style"]);
    var firstDateFieldRef = react_2.useRef();
    var secondDateFieldRef = react_2.useRef();
    var _a = styles_1.useStyles(createStyles, disabled), classes = _a.classes, css = _a.css;
    var className = css(classes.div, props.invalid && classes.invalid, props.style);
    var handleMinMaxDates = function (date) {
        if (minDate && maxDate) {
            return date && date >= minDate && date <= maxDate ? date : undefined;
        }
        if (minDate) {
            return date && date >= minDate ? date : undefined;
        }
        if (maxDate) {
            return date && date <= maxDate ? date : undefined;
        }
        return date;
    };
    var onChangeStart = function (date) {
        var startDate = handleMinMaxDates(date);
        var endDate = (value === null || value === void 0 ? void 0 : value.startDate) && (value === null || value === void 0 ? void 0 : value.endDate) && startDate && startDate > (value === null || value === void 0 ? void 0 : value.endDate) ? undefined : value === null || value === void 0 ? void 0 : value.endDate;
        var aux = {
            startDate: startDate,
            endDate: endDate,
        };
        onChange && onChange(aux);
        if (startDate) {
            secondDateFieldRef.current.focus();
        }
    };
    var onChangeFinal = function (date) {
        var auxFinalDate = handleMinMaxDates(date);
        var startDate = (value === null || value === void 0 ? void 0 : value.startDate) && (value === null || value === void 0 ? void 0 : value.endDate) && auxFinalDate && auxFinalDate < (value === null || value === void 0 ? void 0 : value.startDate)
            ? auxFinalDate
            : value === null || value === void 0 ? void 0 : value.startDate;
        var endDate = (value === null || value === void 0 ? void 0 : value.startDate) && (value === null || value === void 0 ? void 0 : value.endDate) && auxFinalDate && auxFinalDate < (value === null || value === void 0 ? void 0 : value.startDate) ? undefined : auxFinalDate;
        var aux = {
            startDate: startDate,
            endDate: endDate,
        };
        onChange && onChange(aux);
    };
    var onClearStart = function () {
        var aux = { startDate: undefined, endDate: value.endDate };
        onChange && onChange(aux);
        firstDateFieldRef.current.focus();
    };
    var onClearFinal = function () {
        var aux = { startDate: value.startDate, endDate: undefined };
        onChange && onChange(aux);
        secondDateFieldRef.current.focus();
    };
    var defaultHandleOnClick = function () { return firstDateFieldRef.current.focus(); };
    var onInputOnFocusInicial = function () { return onInputOnFocus && onInputOnFocus(1); };
    var onInputOnFocusFinal = function () { return onInputOnFocus && onInputOnFocus(2); };
    var handleIconClick = onIconClick ? onIconClick : defaultHandleOnClick;
    var locale = i18n_1.useLocale();
    return (react_1.default.createElement("div", { ref: divRef },
        react_1.default.createElement("div", { className: className },
            react_1.default.createElement("div", { className: classes.fieldWrapper },
                react_1.default.createElement(DateField_1.DateInput, __assign({ clearable: clearable, name: name ? name + ".startDate" : 'startDate', disabled: disabled, inputRef: react_3.composeRefs(firstDateFieldRef, initialInputRef), onChange: onChangeStart, onClear: onClearStart, placeholder: locale.dateInput.placeholder, style: classes.dateField, value: value === null || value === void 0 ? void 0 : value.startDate, onFocus: onInputOnFocusInicial }, rest))),
            react_1.default.createElement("span", { className: classes.spanWrapper },
                react_1.default.createElement("strong", null, rangeSeparator ? rangeSeparator : locale.dateRangeField.separator)),
            react_1.default.createElement("div", { className: classes.fieldWrapper },
                react_1.default.createElement(DateField_1.DateInput, __assign({ clearable: clearable, name: name ? name + ".endDate" : 'endDate', disabled: disabled, inputRef: react_3.composeRefs(secondDateFieldRef, finalInputRef), onChange: onChangeFinal, onClear: onClearFinal, placeholder: locale.dateInput.placeholder, style: classes.dateField, value: value === null || value === void 0 ? void 0 : value.endDate, onFocus: onInputOnFocusFinal }, rest))),
            react_1.default.createElement("span", { className: classes.iconWrapper },
                react_1.default.createElement(__1.Button, { size: 'small', skin: 'ghost', tabIndex: -1, onClick: handleIconClick, style: classes.icon, disabled: disabled },
                    react_1.default.createElement(Icon_1.Icon, { icon: icon }))))));
}
exports.BaseDateRangeInput = BaseDateRangeInput;
BaseDateRangeInput.defaultProps = {
    icon: 'calendarOutline',
    clearable: true,
};
var createStyles = function (theme, disabled) {
    var divStyle = createBaseDivStyle(theme);
    return {
        div: __assign(__assign({}, divStyle.base), { ':not(:disabled):hover': divStyle.hover, ':not(:disabled):active': divStyle.active, ':focus-within': {
                ':not(:disabled)': divStyle.focus,
            }, background: disabled && theme.pallete.surface.background }),
        invalid: divStyle.invalid,
        spanWrapper: {
            alignItems: 'center',
            background: 'transparent',
            color: disabled && theme.pallete.text.disabled,
            cursor: 'default',
            display: 'flex',
            position: 'relative',
        },
        dateField: {
            border: 'none',
            '::placeholder': {
                color: theme.pallete.text.secondary,
            },
            '&:focus': {
                boxShadow: 'none !important',
            },
        },
        fieldWrapper: {
            flex: 1,
        },
        icon: {
            padding: 'calc(0.25rem - 2px) calc(0.5rem - 1px)',
            borderRadius: 'inherit',
            '&:focus': {
                boxShadow: 'none',
            },
        },
        iconWrapper: {
            backgroundColor: theme.pallete.gray.c90,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '2.5rem',
            borderTopRightRadius: 1,
            borderBottomRightRadius: 1,
        },
    };
};
var createBaseDivStyle = function (theme) { return ({
    base: {
        backgroundColor: theme.pallete.surface.main,
        border: '1px solid' + theme.pallete.gray.c70,
        borderRadius: theme.radius.input,
        cursor: 'default',
        display: 'flex',
        position: 'relative',
        transition: 'box-shadow .2s ease',
        '&:required': {
            boxShadow: 'none',
        },
    },
    active: {
        borderColor: theme.pallete.primary.main,
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.09)',
    },
    focus: {
        boxShadow: styles_1.focusBoxShadow(theme),
        outline: 'none',
    },
    hover: {
        borderColor: theme.pallete.gray.c60,
    },
    invalid: {
        border: 'solid 1px ' + theme.pallete.status.danger.main,
        '&:focus-within': {
            ':not(:disabled)': {
                border: 'solid 1px ' + theme.pallete.gray.c80,
                boxShadow: styles_1.focusBoxShadow(theme, 'danger'),
            },
        },
    },
}); };
//# sourceMappingURL=BaseDateRangeInput.js.map